var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.05c0 4.98 3.6 9.1 8.35 9.95l.06-.05h-.01v-7.09H7.9v-2.81h2.5V9.84c0-2.51 1.6-3.92 3.9-3.92.7 0 1.5.1 2.2.2v2.56h-1.3c-1.2 0-1.5.6-1.5 1.41v1.96h2.65l-.45 2.81h-2.2v7.09l-.1.02.05.03A10.12 10.12 0 0 0 22 12.05C22 6.52 17.5 2 12 2S2 6.52 2 12.05Z"
  })));
};
export default SvgFacebook;